import React from "react";

export const LogoMark = ({ className = "h-11 w-11" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="pbc-holo" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#00f0ff" />
        <stop offset="0.45" stopColor="#ff007f" />
        <stop offset="0.7" stopColor="#ffd700" />
        <stop offset="1" stopColor="#8a2be2" />
      </linearGradient>
    </defs>
    <rect x="14" y="5" width="36" height="54" rx="7" fill="#0b0912" stroke="url(#pbc-holo)" strokeWidth="4" transform="rotate(4 32 32)" />
    <path d="M35 15 L23 37 h9 l-5 15 15 -23 h-10 z" fill="url(#pbc-holo)" />
  </svg>
);

export default function Logo({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="logo-home"
      className="group flex items-center gap-3 outline-none"
      aria-label="Pokebastos Custom Card - Accueil"
    >
      <span className="transition-transform duration-300 group-hover:rotate-6 group-hover:scale-110">
        <LogoMark />
      </span>
      <span className="text-left leading-none">
        <span className="font-display block text-[22px] font-extrabold tracking-wide text-white">
          POKE<span className="text-holo">BASTOS</span>
        </span>
        <span className="block pt-1 font-mono text-[10px] uppercase tracking-[0.3em] text-[#6c6685]">
          Custom Cards
        </span>
      </span>
    </button>
  );
}
